import { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { TemplateStudioModel } from 'common/contracts';
import { templateStudioStateService } from 'state/template-studio.state.service';
import { z } from 'zod';

import { PromotionDesignsMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const PROMOTION_OBJECT_PATH = 'promotion';

const getPromotionsDesignsByFilter = ({
  themes
}: {
  themes: TemplateStudioModel['promotion']['themes'];
}): PromotionDesignsMetadata[] => {
  const relevantPromotionDesigns =
    templateStudioStateService.relevantPromotionDesigns.get() || [];

  return relevantPromotionDesigns.filter((currentDesign) => {
    return (
      !themes || themes.length === 0 || themes.includes(currentDesign.theme)
    );
  });
};

export const PromotionDesignsSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const promotionObject: TemplateStudioModel[typeof PROMOTION_OBJECT_PATH] =
    useWatch({
      control,
      name: PROMOTION_OBJECT_PATH
    });

  const { themes } = promotionObject;

  const designs = useMemo(() => {
    return getPromotionsDesignsByFilter({ themes });
  }, [themes]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="promotion.selectedDesignId"
        />
      ))}
    </>
  );
};
